import { render } from "./AddTask.vue?vue&type=template&id=ab79fc4e&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=ab79fc4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab79fc4e"]])

export default __exports__